/**
 * Bridges OneTrust cookie consent to Shopify's Customer Privacy API.
 * Ported from the legacy theme (assets/consentapi.js).
 *
 * OneTrust categories → Shopify consent:
 *   C0002 (Performance) → analytics
 *   C0003 (Functional)  → preferences
 *   C0004 (Targeting)   → marketing
 *
 * Listens for the `onetrust:updated` event dispatched by `window.OptanonWrapper`
 * (defined in layout/theme.liquid), which OneTrust calls on load and on every consent change.
 */
(() => {
  const ANALYTICS_COOKIES = ['_shopify_sa_p', '_shopify_sa_t', '_shopify_s', '_shopify_y', '_y', '_fbp', '__kla_id'];

  /** @type {string | null} */
  let appliedGroups = null;

  /**
   * @param {string} activeGroups - OneTrust's comma-delimited active groups, e.g. ",C0001,C0002,"
   */
  function getTrackingConsent(activeGroups) {
    return {
      analytics: activeGroups.includes('C0002'),
      preferences: activeGroups.includes('C0003'),
      marketing: activeGroups.includes('C0004'),
      sale_of_data: false,
    };
  }

  /**
   * @param {string} name
   */
  function purgeCookie(name) {
    const expires = 'expires=Thu, 01 Jan 1970 00:00:01 GMT';
    const hostname = window.location.hostname;
    const rootDomain = hostname.replace(/^www\./, '');

    document.cookie = `${name}=; path=/; ${expires}`;
    document.cookie = `${name}=; path=/; domain=${hostname}; ${expires}`;
    document.cookie = `${name}=; path=/; domain=.${rootDomain}; ${expires}`;
  }

  /**
   * @param {{ analytics: boolean }} trackingConsent
   */
  function syncThirdPartyCookies(trackingConsent) {
    if (trackingConsent.analytics) {
      purgeCookie('__kla_off');
    } else {
      ANALYTICS_COOKIES.forEach(purgeCookie);
      document.cookie = '__kla_off=true; path=/';
    }
  }

  /**
   * @param {ReturnType<typeof getTrackingConsent>} trackingConsent
   * @param {() => void} callback
   */
  function sendShopifyConsent(trackingConsent, callback) {
    if (!window.Shopify?.loadFeatures) {
      callback();
      return;
    }

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) {
        console.error('Shopify consent tracking API error:', error);
        callback();
        return;
      }

      window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, callback);
    });
  }

  function applyConsent() {
    const activeGroups = window.OnetrustActiveGroups;
    if (typeof activeGroups !== 'string' || activeGroups === appliedGroups) return;

    // The first call reflects consent already stored for this visitor; later calls mean the visitor
    // just changed their choices, so reload to start or stop tracking scripts already on the page.
    const isConsentChange = appliedGroups !== null;
    appliedGroups = activeGroups;

    const trackingConsent = getTrackingConsent(activeGroups);
    syncThirdPartyCookies(trackingConsent);

    if (trackingConsent.analytics && trackingConsent.preferences && trackingConsent.marketing) {
      window.Yotpo?.allowCookies?.();
    }

    sendShopifyConsent(trackingConsent, () => {
      if (isConsentChange) window.location.reload();
    });
  }

  document.addEventListener('onetrust:updated', applyConsent);

  // OneTrust may have already initialized before this script ran.
  applyConsent();
})();
